import React from 'react';
import heroLogo from '../assets/hero-logo.svg';

export default function Hero() {
    return (
        <div className="w-full flex justify-center pt-8 px-4 md:px-6">
            <div className="w-full max-w-[1140px] flex flex-col items-center gap-8" style={{ gap: '32px' }}>
                {/* Hero Logo with glow effect */}
                <div className="flex justify-center">
                    <img
                        src={heroLogo}
                        alt="Trust List Logo"
                        className="hero-logo-glow w-[248px] h-[200px]"
                    />
                </div>

                {/* Title and Description */}
                <div className="flex flex-col items-center gap-2 w-full max-w-[1140px] pb-4" style={{ gap: '8px' }}>
                    <h1 className="text-white text-center font-bold leading-[1.3em] font-manrope text-[40px]">
                        One list. All the tools you need.
                    </h1>
                    <p className="text-[#D5CED4] text-center font-normal leading-[1.7em] font-manrope max-w-[1140px] text-[14px]">
                        Explore all categories and discover the tools that work best for you.
                    </p>
                </div>
            </div>
        </div>
    );
}

